import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { PriorityRecheck } from '@core/models/models/priority-recheck.model';

@Component({
  selector: 'caremoni-status',
  templateUrl: './status.component.html',
  styleUrl: './status.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class StatusComponent implements OnInit {
  @Input() data: any = undefined;
  priorityRecheck!: PriorityRecheck;

  public priority: string = '';
  public recheck: string = '';

  public background: string = '';
  public color: string = '';

  public backgroundRecheck: string = '';
  public colorRecheck: string = '';

  ngOnInit(): void {
    if(!this.data)
      return;
    
    this.priorityRecheck = typeof this.data === 'string'
      ? this.safeParsePriority(this.data)
      : this.data;
    this.priority = this.priorityRecheck?.priority ?? '';
    const recheckVal = this.priorityRecheck?.recheck;
    if (typeof recheckVal === 'string' && recheckVal.includes("再検")) {
      this.recheck = "再検"
    }

    switch (this.priority) {
      case '優先': 
        this.background = '#ec4899';//Mau tim
        this.color = 'white';
        break;
      case '最初':
        this.background = '#10b981',//Mau Xanh Lá
        this.color = 'white';
        break;
      case '再検':
        this.background = '#ffd937',//MAU VANG
        this.color = 'black'
        break;
      case '最後':
        this.background = '#f97316',//Mau cam
        this.color = 'white'
        break;
      default:
        this.priority = ''; // Ngoài option trên thì hiện rỗng.
        break;
    }
    if(this.recheck.includes("再検"))
      {
          this.backgroundRecheck = '#ffd937',//Mau cam
          this.colorRecheck = 'black'
      }
  }

  private safeParsePriority(value: string): PriorityRecheck {
    try {
      const parsed = JSON.parse(value);
      return (parsed && typeof parsed === 'object') ? parsed : ({} as PriorityRecheck);
    } catch {
      return {} as PriorityRecheck;
    }
  }
}
